
//certifications
export const GetKudosById = (personnelID) => {
      return $.get('Personnel/GetKudosById?Id='+personnelID)
}
export const GetKudosGivenByUsers = (personnelID) => {
  return $.get('Personnel/GetKudosGivenByUsers')
}

export const DeleteKudos = (KudosId) => {
    return $.post('Personnel/DeleteKudos?KudosId='+KudosId)
}
export const AddKudos = (model) => {
  return $.post('Personnel/AddKudos',model)
}
export const UpdateKudos = (model) => {
  return $.post('Personnel/UpdateKudos',model)
}
export const GetCommendableActionTypes=()=>{
  return $.get('Personnel/GetCommendableActionTypes')
}







// WEBPACK FOOTER //
// ./src/components/Kudos/Kudos.service.js